var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-title"},[(_vm.isRequired)?_c('span',[_vm._v("*")]):_vm._e(),_vm._v(_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }